type SwishCancelPaymentRequest = {
    /**
     * The operation to perform. Possible values: `replace`
     * @type {"replace"}
     */
    op: "replace";
    /**
     * Document path. Possible values: `/status`
     * @type {"/status"}
     */
    path: "/status";
    /**
     * Document path. Possible values: `cancelled`
     * @type {"cancelled"}
     */
    value: "cancelled";
};

const createSwishPaymentCancelRequest = (): SwishCancelPaymentRequest => {
    return {
        op: "replace",
        path: "/status",
        value: "cancelled",
    };
};

export type { SwishCancelPaymentRequest };
export { createSwishPaymentCancelRequest };
